/** A labelled run of rail items. */

import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/cn";

import "../internal/base.css";
import "./NavGroup.css";

export interface NavGroupProps {
  readonly label?: ReactNode;
  readonly className?: string;
  readonly style?: CSSProperties;
  readonly children?: ReactNode;
}

export function NavGroup({ label, className, style, children }: NavGroupProps) {
  return (
    <div className={cn("al-navgroup", className)} style={style}>
      {label !== undefined ? <div className="al-eyebrow al-navgroup-label">{label}</div> : null}
      <div className="al-navgroup-items">{children}</div>
    </div>
  );
}
